import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IDynamicForm, IFormElementsData, IFormMessage, ISingleFormElementData } from './DynamicForm';

interface IFormsState {
    forms: Array<IDynamicForm>,
    data: IFormElementsData
}

const initialState: IFormsState = {
    forms: [],
    data: {}
}

const formsSlice = createSlice({
    name: "forms",
    initialState,
    reducers: {
        addNewForm: (state: IFormsState, action: PayloadAction<IDynamicForm>) => {
            const forms = state.forms
            if (forms.filter(form => form.name === action.payload.name).length === 0){
                state.forms.push(action.payload)
            }
        },
        createOrUpdateForm: (state: IFormsState, action: PayloadAction<IDynamicForm>) => {
            const forms = state.forms
            if (forms.filter(form => form.name === action.payload.name).length === 0){
                state.forms.push(action.payload)
            }else{
                const formIndex = forms.findIndex(form => form.name === action.payload.name)
                state.forms[formIndex] = action.payload
            }
        },
        updateFormMessage: (state: IFormsState, action: PayloadAction<{ formName: string, message: IFormMessage }>) => {
            let forms = state.forms
            
            if (forms && forms.length > 0){
                forms.map((form) => {
                    if (form.name === action.payload.formName){

                        const formIndex = forms.findIndex(form => form.name === action.payload.formName)
                        forms[formIndex].message = action.payload.message

                    }
                })
            }

            state.forms = forms
        },
        updateFormLoading: (state: IFormsState, action: PayloadAction<{ formName: string, loading: boolean }>) => {
            let forms = state.forms
            
            if (forms && forms.length > 0){
                forms.map((form) => {
                    if (form.name === action.payload.formName){

                        const formIndex = forms.findIndex(form => form.name === action.payload.formName)
                        forms[formIndex].loading = action.payload.loading

                    }
                })
            }

            state.forms = forms
        },
        createOrUpdateElementData: (state: IFormsState, action: PayloadAction<ISingleFormElementData>) => {
            const payload = action.payload
            state.data[payload.name] = payload
        },
        addManyElementsData: (state: IFormsState, action: PayloadAction<Array<ISingleFormElementData>>) => {
            const payload = action.payload

            if (payload.length > 0){
                payload.map(elementData => state.data[elementData.name] = elementData)
            }
        },
    }
})

export const { addNewForm, createOrUpdateForm, createOrUpdateElementData, addManyElementsData, updateFormMessage, updateFormLoading } = formsSlice.actions
export default formsSlice.reducer